import { useEffect, useState } from "react";
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "../firebase";
import { useAuth } from "../context/AuthContext";
import {
  isRecoveryDeleteAccessOwner,
  isValidRecoveryDeleteEmail,
  normalizeRecoveryDeleteEmail,
  RECOVERY_DELETE_ACCESS_COLLECTION,
} from "./recoveryDeleteAccess";

export const useRecoveryDeleteAccess = () => {
  const { currentUser } = useAuth();
  const [access, setAccess] = useState({
    loading: true,
    hasRecoveryDeleteAccess: false,
  });

  useEffect(() => {
    if (!currentUser) {
      setAccess({ loading: false, hasRecoveryDeleteAccess: false });
      return undefined;
    }

    if (isRecoveryDeleteAccessOwner(currentUser)) {
      setAccess({ loading: false, hasRecoveryDeleteAccess: true });
      return undefined;
    }

    const email = normalizeRecoveryDeleteEmail(currentUser.email);
    if (!isValidRecoveryDeleteEmail(email)) {
      setAccess({ loading: false, hasRecoveryDeleteAccess: false });
      return undefined;
    }

    setAccess({ loading: true, hasRecoveryDeleteAccess: false });

    return onSnapshot(
      doc(db, RECOVERY_DELETE_ACCESS_COLLECTION, email),
      (snapshot) => {
        setAccess({
          loading: false,
          hasRecoveryDeleteAccess: snapshot.exists(),
        });
      },
      (error) => {
        console.error("Unable to load Recovery Delete Access", error);
        setAccess({ loading: false, hasRecoveryDeleteAccess: false });
      },
    );
  }, [currentUser]);

  return access;
};
